/* ============================================================
   ARAB cart drawer, wired to the Shopify Cart AJAX API.
   Same visual behaviour as the approved design:
   free delivery progress, one relevant suggestion, one click add,
   checkout button always reachable.
   ============================================================ */
(function () {
  var FREE = 30.000;                 // free delivery threshold, in shop currency
  var scrim   = document.getElementById('cart-scrim');
  var panel   = document.getElementById('cart');
  var openBtn = document.getElementById('cart-open');
  var closeBtn= document.getElementById('cart-close');
  var body    = document.getElementById('cart-body');
  var foot    = document.getElementById('cart-foot');
  var badge   = document.getElementById('cart-badge');
  var reward  = document.getElementById('reward');
  if (!panel) return;

  var lastFocus = null;
  var CART = { items: [], total_price: 0, item_count: 0 };

  var isAr  = function () { return document.documentElement.dir === 'rtl'; };

  /* اسم المنتج بلغة الصفحة. cart.js يرجّع الإنجليزي فقط،
     فنأخذ العربي من الخريطة الممرّرة من Liquid حسب الـ handle. */
  function nameFor(item) {
    var en = item.product_title;
    var ar = (window.ARAB_NAMES || {})[item.handle] || en;
    return { en: en, ar: ar };
  }
  var money = function (cents) {
    var n = (cents / 100).toFixed(3);
    return n + ' KWD';
  };

  function get() {
    return fetch(window.ARAB.routes.cart + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { CART = c; render(); return c; });
  }

  function add(id, qty) {
    return fetch(window.ARAB.routes.cartAdd + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: qty || 1 }] })
    }).then(function () { return get(); }).then(function () { open(); });
  }

  function change(key, qty) {
    return fetch(window.ARAB.routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function () { return get(); });
  }

  function esc(t) {
    return String(t == null ? '' : t)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function lineHTML(it) {
    var n = nameFor(it);
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
    return '<div class="cart-line">'
      + '<span class="thumb">' + (img ? '<img src="' + img + '" alt="">' : '') + '</span>'
      + '<div class="info">'
      +   '<h3 data-en="' + esc(n.en) + '" data-ar="' + esc(n.ar) + '">' + (isAr() ? n.ar : n.en) + '</h3>'
      +   (it.variant_title && it.variant_title !== 'Default Title'
            ? '<span class="sz">' + it.variant_title + '</span>' : '')
      +   '<div class="ln-bottom">'
      +     '<span class="qty">'
      +       '<button type="button" data-act="dec" data-k="' + it.key + '" aria-label="Decrease quantity">'
      +         '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M5 12h14"/></svg></button>'
      +       '<b>' + it.quantity + '</b>'
      +       '<button type="button" data-act="inc" data-k="' + it.key + '" aria-label="Increase quantity">'
      +         '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg></button>'
      +     '</span>'
      +     '<span class="ln-price"><bdi>' + money(it.line_price) + '</bdi></span>'
      +     '<button class="ln-remove" type="button" data-act="del" data-k="' + it.key + '" aria-label="Remove item">'
      +       '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13"/></svg></button>'
      +   '</div>'
      + '</div></div>';
  }

  /* One suggestion only: the cheapest product that closes the free delivery gap */
  function suggestHTML() {
    var pool = window.ARAB_SUGGEST || [];
    if (!pool.length) return '';
    var inCart = CART.items.map(function (i) { return i.variant_id; });
    var free = FREE * 100;
    var gap = free - CART.total_price;
    var avail = pool.filter(function (p) { return inCart.indexOf(p.id) === -1; });
    if (!avail.length) return '';

    var pick = null, closes = false;
    if (gap > 0) {
      var fits = avail.filter(function (p) { return p.price >= gap; })
                      .sort(function (a, b) { return a.price - b.price; });
      if (fits.length) { pick = fits[0]; closes = true; }
    }
    if (!pick) pick = avail.slice().sort(function (a, b) { return a.price - b.price; })[0];
    if (!pick) return '';

    var hEn = closes ? 'Add this and delivery is free' : 'Goes well with your bag';
    var hAr = closes ? 'أضفه ويصير التوصيل مجاني' : 'يناسب اللي بسلتك';
    return '<div class="suggest">'
      + '<div class="suggest-h">'
      +   '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 3l2.2 5.6L20 10l-4.4 3.6L17 20l-5-3.2L7 20l1.4-6.4L4 10l5.8-1.4z"/></svg>'
      +   '<span data-en="' + hEn + '" data-ar="' + hAr + '">' + hEn + '</span>'
      + '</div>'
      + '<div class="suggest-b">'
      +   '<span class="thumb"><img src="' + pick.image + '" alt=""></span>'
      +   '<div class="info"><h4 data-en="' + esc(pick.title) + '" data-ar="' + esc(pick.title_ar || pick.title) + '">' + (isAr() ? (pick.title_ar || pick.title) : pick.title) + '</h4>'
      +     '<p class="p"><bdi>' + money(pick.price) + '</bdi></p></div>'
      +   '<button class="suggest-add" type="button" data-act="sug" data-id="' + pick.id + '" data-en="Add" data-ar="أضف">Add</button>'
      + '</div></div>';
  }

  function emptyHTML() {
    return '<div class="cart-empty">'
      + '<span class="ic"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M6 7h12l-1.2 12H7.2z"/><path d="M9 7a3 3 0 0 1 6 0"/></svg></span>'
      + '<h3 data-en="Your bag is empty" data-ar="سلتك فاضية">Your bag is empty</h3>'
      + '<p data-en="Pick a tin or a gift bundle and it will show up here."'
      + ' data-ar="اختر علبة أو باقة هدية وبتظهر هنا.">Pick a tin or a gift bundle and it will show up here.</p>'
      + '<a class="btn btn-primary" href="' + window.ARAB.routes.root + '" data-act="close-shop"'
      + ' data-en="Browse the collection" data-ar="تصفّح المجموعة">Browse the collection</a>'
      + '</div>';
  }

  function renderReward() {
    if (!reward) return;
    if (!CART.item_count) { reward.hidden = true; return; }
    reward.hidden = false;
    var free = FREE * 100;
    var gap = Math.max(0, free - CART.total_price);
    var done = gap <= 0;
    reward.classList.toggle('done', done);
    var bar = document.getElementById('reward-bar');
    if (bar) bar.style.width = Math.min(100, CART.total_price / free * 100) + '%';
    var msg = document.getElementById('reward-msg');
    if (!msg) return;
    if (done) {
      msg.setAttribute('data-en', 'Delivery is free on this order');
      msg.setAttribute('data-ar', 'التوصيل مجاني على هذا الطلب');
    } else {
      msg.setAttribute('data-en', 'You are <b>' + money(gap) + '</b> away from free delivery');
      msg.setAttribute('data-ar', 'باقي <b><bdi>' + money(gap) + '</bdi></b> على التوصيل المجاني');
    }
  }

  function render() {
    var n = CART.item_count;
    body.innerHTML = n
      ? '<div class="cart-lines">' + CART.items.map(lineHTML).join('') + '</div>' + suggestHTML()
      : emptyHTML();
    foot.hidden = !n;
    var nb = document.getElementById('cart-n');
    if (nb) { nb.hidden = !n; nb.textContent = n; }
    var sum = document.getElementById('cart-sum');
    if (sum && n) sum.innerHTML = '<bdi>' + money(CART.total_price) + '</bdi>';
    if (badge) { badge.hidden = !n; badge.textContent = n; }
    renderReward();
    if (window.applyLang) window.applyLang(window.currentLang ? window.currentLang() : (isAr() ? 'ar' : 'en'));
  }

  function open() {
    lastFocus = document.activeElement;
    scrim.hidden = false; panel.hidden = false;
    requestAnimationFrame(function () {
      scrim.classList.add('open'); panel.classList.add('open');
    });
    openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    closeBtn.focus();
  }

  function close() {
    scrim.classList.remove('open'); panel.classList.remove('open');
    openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setTimeout(function () { scrim.hidden = true; panel.hidden = true; }, 340);
    if (lastFocus) lastFocus.focus();
  }

  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = panel.querySelectorAll('button, [href]');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  openBtn.addEventListener('click', function () { get().then(open); });
  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !panel.hidden) close();
  });

  body.addEventListener('click', function (e) {
    var b = e.target.closest('[data-act]');
    if (!b) return;
    var act = b.dataset.act;
    if (act === 'close-shop') { close(); return; }
    if (act === 'sug') { add(parseInt(b.dataset.id, 10), 1); return; }
    var key = b.dataset.k;
    var line = CART.items.filter(function (i) { return i.key === key; })[0];
    if (!line) return;
    if (act === 'inc') change(key, line.quantity + 1);
    if (act === 'dec') change(key, line.quantity - 1);
    if (act === 'del') change(key, 0);
  });

  /* Add to bag buttons anywhere on the page */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-bag]');
    if (!b || b.disabled) return;
    e.preventDefault();
    add(parseInt(b.dataset.bag, 10), 1);
  });

  window.arabCartRefresh = get;
  get();
})();
